import { writable, type Writable } from "svelte/store";

let envSubdomain: `${string}.` | "";
let mulesoftSubdomain: `${string}.` | "";

switch (import.meta.env.VITE_JOB_BASE_NAME) {
  case "undefined":
  case undefined: //local development subdomain
  case "DEV1":
  case "DEV2":
  case "DEV3":
    mulesoftSubdomain = "dev.";
    break;
  case "QA1":
    mulesoftSubdomain = "qa.";
    break;
  case "STAGE":
    mulesoftSubdomain = "stg.";
    break;
  case "PROD-SUPPORT":
    mulesoftSubdomain = "ps.";
    break;
  case "PROD":
    mulesoftSubdomain = "";
    break;
  default:
    mulesoftSubdomain = `${import.meta.env.VITE_JOB_BASE_NAME.toLowerCase()}.`;
}
switch (import.meta.env.VITE_JOB_BASE_NAME) {
  case "undefined":
  case undefined: //local development subdomain
    envSubdomain = "dev3.";
    break;
  case "STAGE":
    envSubdomain = "stg.";
    break;
  case "PROD-SUPPORT":
    envSubdomain = "ps.";
    break;
  case "PROD":
    envSubdomain = "";
    break;
  default:
    envSubdomain = `${import.meta.env.VITE_JOB_BASE_NAME.toLowerCase()}.`;
}

type ApiParams = {
  baseURL: string;
  mulesoftUrl: string;
  clientId: string;
  clientSecret: string;
  getUserDetails: string;
  checkHdsAuth: string;
  storeId: string;
  catalogId: string;
  langId: string;
  login: string;
};

const storeId = (() => window.WCParamJS?.storeId ?? "10051")();
const catalogId = (() => window.WCParamJS?.catalogId ?? "10054")();
const langId = (() => window.WCParamJS?.langId ?? "-1")();

let ApiParams: Writable<ApiParams> = writable({
  baseURL: "https://" + envSubdomain + "hdsupplysolutions.com",
  mulesoftUrl: "https://" + mulesoftSubdomain + "api.hdsupply.com/ebiz",
  clientId: window.cid,
  clientSecret: window.cs,
  getUserDetails: `/wcs/resources/store/${storeId}/hdsmember/getUserDetails`,
  checkHdsAuth: `/HdsAuth?storeId=${storeId}`,
  storeId: storeId,
  catalogId: catalogId,
  langId: langId,
  login: `/LogonForm?myAcctMain=1&catalogId=${catalogId}&langId=-1&storeId=${storeId}&returnPage=apm`,
});
export default ApiParams;
